import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { CampaignContent } from '@tm/client-form/src/components/campaign/CampaignContent'
import { CampaignProgressBar } from '@tm/client-form/src/components/campaign/CampaignProgressBar'
import { ThirdPartyCollectSource } from '@tm/types/survey/third-party-collect'
import { PlatformView } from '../Review/PlatformView'

export type ThanksViewProps = {
  title: string
  text: string
  review?: string | null
  sources?: ThirdPartyCollectSource[]
  lang: string
  autoRedirectEnabled?: boolean
  preview?: boolean
}

export function ThanksView({
  title,
  text,
  review = null,
  sources,
  lang,
  preview = false,
  autoRedirectEnabled,
}: ThanksViewProps) {
  const urlSearchParams = new URLSearchParams(location.search)
  const inPreview = preview || urlSearchParams.get('preview')
  const noRedirect = !autoRedirectEnabled || !!inPreview
  return (
    <Stack sx={{ textAlign: 'center', maxWidth: 480, mx: 'auto', gap: 2, width: 1 }} data-thanks-page={true}>
      <Typography variant="subtitle1">{title}</Typography>
      <CampaignContent content={text} />
      {!!sources && <PlatformView sources={sources} lang={lang} noRedirect={noRedirect} copyText={review} />}
      <CampaignProgressBar position="after" overrideFinalPage />
    </Stack>
  )
}
